<template>
  <div>
    <!-- <chart-bar
      :completed="getPerc(metric.totalRequests, metric.totalResponses)"
      :colour="colour"
      :description="description"
      :icon="icon"
      :requests="metric.totalRequests"
      :responses="metric.response"
    /> -->
    <graph-metric-bar
      :completed="getPerc(metric.totalRequests, metric.totalResponses)"
      :colour="colour"
      :description="description"
      :icon="icon"
    />
    <div
      class="pl-5" style="margin-left: 75px; font-size: smaller;"
    >
      <p>
        Response Success:
        {{ getPerc(metric.totalResponses, metric.totalSuccess) }}%
      </p>
      <p>
        Responses:
        {{ getPerc(metric.totalRequests, metric.totalSuccess) }}%
      </p>
      <p>
        Request Success:
        {{ getPerc(metric.totalRequests, metric.totalSuccess) }}%
      </p>
    </div>
  </div>
</template>

<script>
import GraphMetricBar from './graph-metric-bar';
// import ChartBar from './ChartBar';

export default {
  components: {
    GraphMetricBar,
    // ChartBar,
  },
  props: {
    colour: {
      type: String,
      default: 'secondary',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'mdi-flip-to-front',
    },
    metric: {
      type: Object,
      default: null,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getPerc(requests, responses) {
      let result = 0;
      if (this.$attrs.reversed) {
        result = Math.round(responses / (requests + responses) * 100);
      }
      result = Math.round(responses / requests * 100);
      if (Number.isNaN(result)) {
        result = 0;
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
